
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_people/components/profile_editor/templates/contact_list"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class='contacts'></div>\n<div class='sub_section_footer'>\n  <span class='add_contact opal_ui btn_create'>\n    <span class='sprite-global glyph'></span>\n    <span class='label'>\n      "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"button_label") || (depth0 != null ? lookupProperty(depth0,"button_label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"button_label","hash":{},"data":data,"loc":{"start":{"line":6,"column":6},"end":{"line":6,"column":22}}}) : helper)))
    + "\n    </span>\n  </span>\n</div>\n";
},"useData":true});
    }).call(this);
  